import axios from 'axios'
import { userApiConfig, userConfig, webConfig } from '@base/configs'


export const userChangePassword = axios.create({
  method: 'post',
  baseURL: `${webConfig.baseURL}/password/change/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const customerGet = axios.create({
  method: 'get',
  baseURL: `${userConfig.baseURL}/customer/`,
  headers: { 'Accept': 'application/json' },
})

export const updateCustomer = axios.create({
  method: 'patch',
  baseURL: `${userConfig.baseURL}/customer/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getCustomerProfile = axios.create({
  method: 'get',
  baseURL: `${userConfig.baseURL}/customer/profile/`,
  headers: { 'Accept': 'application/json' },
})

export const updateCustomerProfile = axios.create({
  method: 'patch',
  baseURL: `${userConfig.baseURL}/customer/profile/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const setTablePageSize = axios.create({
  method: 'patch',
  baseURL: `${userConfig.baseURL}/customer/table_page_size/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const loginCustomerByLink = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/login_link/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const switchCustomerAccount = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/switch_customer_account/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getCustomerAccounts = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/customer_accounts/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})


// Market

export const getUserMarket = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/user_market/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Sale Lines

export const getUserSaleLines = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/aggregated_sale_lines/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getUserSaleLinesSummary = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/sale_lines/summary/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Product sheets

export const getUserProductSheets = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const createUserProductSheet = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const updateUserProductSheet = axios.create({
  method: 'patch',
  baseURL: `${userApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteUserProductSheet = axios.create({
  method: 'delete',
  baseURL: `${userApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})


// Products

export const getUserProducts = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const createUserProduct = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getProductSaleLines = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/product_sale_lines/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Campaigns

export const userProductCampaign = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/product_campaigns/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Payments

export const getPaymentReports = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/payment_reports/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Online Booking

export const getAllBookings = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/bookings/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfTypes = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/shelf_types/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfPeriodPrices = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/shelf_period_prices/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfTypeServices = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/shelf_type_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getShelfTypeAvailability = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/shelf_type_availability/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getBookingRequest = axios.create({
  method: 'get',
  baseURL: `${userApiConfig.baseURL}/booking_requests/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingRequestReserve = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/booking_request/reserve/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingRequestInitPayment = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/booking_request/init_payment/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingRequestConfirmPayment = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/booking_request/confirm_payment/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingRequestBookWithoutPayment = axios.create({
  method: 'post',
  baseURL: `${userApiConfig.baseURL}/booking_request/book_without_payment/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingRequestDelete = axios.create({
  method: 'delete',
  baseURL: `${userApiConfig.baseURL}/booking_request/delete/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bookingPaymentTransaction = axios.create({
  method: 'delete',
  baseURL: `${userApiConfig.baseURL}/booking_payment_transaction/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})